<script setup lang="ts">
const props = defineProps({
  title: String,
  highlighted: Boolean,
  href: String,
})
</script>

<template>
  <li>
    <NavigationMenuLink
      class="NavigationMenuLink"
      :as-child="true"
    >
      <NuxtLink
        v-bind="$attrs"
        :to="$url(href)"
        class="ListItemLink"
        :class="{ highlighted }"
      >
        <svg
          v-if="highlighted"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          class="blinking"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="5"
            cy="5"
            r="5"
            fill="white"
          />
        </svg>
        {{ props.title }}
      </NuxtLink>
    </NavigationMenuLink>
  </li>
</template>

<style lang="css" scoped>
.highlighted {
  background-color: var(--blue);
  color: var(--white);
  border-radius: 0.2rem;
  display: flex;
  align-items: baseline;
}

.highlighted:hover {
  color: var(--text-secondary);
}

.blinking {
  animation: 2s blink linear infinite;
  margin-right: 1rem;
}

@keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  80% {
    opacity: 1;
  }
}
</style>
